import React from 'react';
import { Typography, Paper, Box } from '@mui/material';

function PrivacyPolicy() {
  return (
    <Box>
      <Typography variant="h4" component="h1" gutterBottom>
        Privacy Policy
      </Typography>
      
      <Paper elevation={3} sx={{ p: 3 }}>
        <Typography variant="h6" gutterBottom>
          Information We Collect
        </Typography>
        <Typography paragraph>
          We collect information that you provide directly to us when using our fitness and diet planning service, including:
        </Typography>
        <ul>
          <li>Age</li>
          <li>Height</li>
          <li>Current Weight</li>
          <li>Target Weight</li>
          <li>Time frame for achieving goals</li>
        </ul>

        <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
          How We Use Your Information
        </Typography>
        <Typography paragraph>
          We use the information you provide to:
        </Typography>
        <ul>
          <li>Calculate your BMI and fitness metrics</li>
          <li>Generate personalized workout and diet plans</li>
          <li>Improve our service and user experience</li>
        </ul>

        <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
          Data Storage and Security
        </Typography>
        <Typography paragraph>
          We do not store your personal information permanently. All calculations are done locally in your browser, and your data is not transmitted to any servers.
        </Typography>

        <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
          Contact Us
        </Typography>
        <Typography paragraph>
          If you have any questions about this Privacy Policy, please contact us through our Contact page.
        </Typography>

        <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
          Changes to This Policy
        </Typography>
        <Typography paragraph>
          We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.
        </Typography>
      </Paper>
    </Box>
  );
}

export default PrivacyPolicy; 